import Create from './create/CreateUser';
import Individual from './individual/User';
import List from './list/Users';
import Edit from './edit/EditUser'

export default { List, Individual, Create, Edit };
